import { ArtifactRegistry } from './ArtifactRegistry';
import { chalkTextBlockRenderer } from './builtins/chalkTextBlock';
import { textTimelineAnim } from './builtins/anim/textTimeline';
import { primitive2dRenderer } from './builtins/primitive2d.js';
import { kinematics2dAnim } from './builtins/anim/kinematics2d.js';

let defaultRegistry = null;

export function getDefaultArtifactRegistry() {
  if (defaultRegistry) return defaultRegistry;

  defaultRegistry = new ArtifactRegistry();
  defaultRegistry.registerRenderer('chalkTextBlock', chalkTextBlockRenderer);
  defaultRegistry.registerRenderer('primitive2d', primitive2dRenderer);
  defaultRegistry.registerAnim('textTimeline', textTimelineAnim);
  defaultRegistry.registerAnim('kinematics2d', kinematics2dAnim);
  return defaultRegistry;
}
